App.factory('lifeInsuranceWithPaymentsService', ['$q', 'baseService', 'Config', 'Configurator', '$rootScope', function ($q, baseService, Config, Configurator, $rootScope) {
    function LifeInsuranceWithPaymentsService() {

        this.isPzu = function () {
            return Configurator.lifeInsuranceWithPayments.insurer === 'Pzu';
        };

        this.isUnum = function () {
            return Configurator.lifeInsuranceWithPayments.insurer === 'Unum';
        };

        this.sendStatements = function (packages) {
            var packagesWrapper = {
                packages: []
            };
            for (const property in packages[0]) {
                packagesWrapper.packages.push(packages[0][property]);
            }
            var json = angular.toJson(packagesWrapper);
            return baseService.post(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/statements', json).then(
                function (success) {
                    console.log('Unum life insurance required statements send');
                    return success;
                },
                function (error) {
                    console.warn('Failed to send Unum life insurance required statements');
                    return error;
                }
            );
        };

        this.saveDeclaration = function (declaration) {
            return baseService.post(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration', angular.toJson(declaration));
        };

        this.getDeclaration = function (uuid) {
            return baseService.get(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/' + uuid);
        };

        this.downloadCertificate = function (uuid) {
            return baseService.download(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/' + uuid + '/certificate');
        };

        this.downloadDeclaration = function (uuid) {
            return baseService.download(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/' + uuid + '/declaration');
        };

        this.changePersonalDetails = function (uuid, personalDetails) {
            return baseService.post(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/' + uuid, angular.toJson(personalDetails));
        };

        this.getAllPackages = function () {
            return baseService.getWithOutAuth(Config.API_URL + '/lifeInsuranceWithPayment/' + Config.COMPANY_ID + '/groups').then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.getInsuranceCoverage = function () {
            return baseService.getWithOutAuth($rootScope.CONFIGURATOR.lifeInsuranceWithPayments.productDetailsUrl).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.available = function () {
            return baseService.get(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/available').then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.isAllowedToSaveDeclaration = function () {
            return baseService.get(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/permission').then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.availableInvitation = function (invitationToken) {
            return baseService.getWithOutAuth(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/availableInvitation/' + invitationToken).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.last = function () {
            return baseService.get(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/last').then(function (success) {
                return success;
            }, function (error) {
                return error;
            }).then(function (data) {
                return data;
            });
        };

        this.dataList = function (data) {
            return baseService.post(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/list', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.withdrawDeclaration = function (uuid) {
            return baseService.post(Config.API_URL + '/lifeInsuranceWithPaymentDeclaration/' + uuid + '/withdraw');
        };
    }

    return new LifeInsuranceWithPaymentsService();
}]);